<template>
  <div>
    <van-nav-bar title="我的福利券" left-arrow @click-left="goableBack()" />

    <van-cell class="cell" value="我的优惠券" is-link @click="onMyCoupon" />

    <van-cell class="cell" value="我的奖票" is-link @click="onMyTicket" />
    <van-cell class="cell" value="我的红包" is-link @click="onMyRedEnvelope" />
  </div>
</template>

<script>
import { Dialog, Toast } from "vant"
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {}
  },
  methods: {
    onMyCoupon() {
      this.$router.push({ name: "coupon" })
    },
    onMyTicket() {
      this.$router.push({ name: "coupon-ticket" })
    },
    onMyRedEnvelope() {
      this.$router.push({ name: "coupon-redenvelope" })
    }
  }
}
</script>

<style lang="less" scoped>
.cell {
  margin-top: 10px;
}
</style>